import { useDisclosure, Box, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { menuButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuDesktop = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Menu isOpen={isOpen}>
      <MenuButton sx={menuButtonStyles} onMouseEnter={onOpen} onMouseLeave={onClose}>
        {menulink}
      </MenuButton>
      <MenuList
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        border="none"
        boxShadow="none"
        rounded="md"
        borderTopLeftRadius="none"
        textAlign="left"
        pt={4}
        pb={0}
        mt={-2}
      >
        <Box rounded="md" mt={2} boxShadow="md" zIndex="2" data-testid="kyr-menu" onClick={onClose}>
          <SubmenuContent
            submenu={submenu}
            color="greyscale.600"
            _hover={{ color: "primary.900", bg: "greyscale.300" }}
            px={4}
            py={2.5}
            mb={0}
            rounded="md"
          />
        </Box>
      </MenuList>
    </Menu>
  );
};
